export default "__VITE_ASSET__nJezyObb__"